/**
 * Gli stati HTTP che il backoffice interpreta. Un solo posto: prima 401 e 403
 * erano ridichiarati in ogni modulo che li leggeva, e l'interceptor del client
 * usava il numero nudo.
 */
export const HTTP_STATUS = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  SERVICE_UNAVAILABLE: 503,
} as const;
